import * as React from 'react';

import * as styles from './styles.css';
import { Skeleton } from 'shared/containers/NewbuildingOffersCarouselContainer/components/Skeleton';

export const NewbuildingOffersSkeleton: React.FC = () => {
  return (
    <>
      {Array.from({ length: 5 }, (_, index) => (
        <div key={index} className={styles['skeleton-item']}>
          <Skeleton />
        </div>
      ))}
    </>
  );
};
